import {Routes} from '@angular/router';
import {ProfileComponent} from './features/patient-management/components/profile/profile.component';
import {RegisterComponent} from './features/patient-management/components/register/register.component';
import {AppointmentFiltersComponent} from './features/appointment-selection/components/appointment-filters/appointment-filters.component';
import {DateSelectionComponent} from './features/appointment-selection/components/date-selection/date-selection.component';
import {TimeSelectionComponent} from './features/appointment-selection/components/time-selection/time-selection.component';
import {SelectedAppointmentComponent} from './features/booking/components/selected-appointment/selected-appointment.component';
import {AppointmentSelectionComponent} from './features/appointment-selection/components/appointment-selection/appointment-selection.component';
import {BookingComponent} from './features/booking/components/booking/booking.component';
import {BookingLoginComponent} from './features/booking/components/login/booking-login.component';
import {ConfirmComponent} from './features/booking/components/confirm/confirm.component';
import {LoginPageComponent} from './features/authentication/components/login-page/login-page.component';
import {SuccessComponent} from './features/booking/components/success/success.component';
import {CourseListComponent} from './features/courses/components/course-list/course-list.component';
import {CoursesComponent} from './features/courses/components/courses/courses.component';
import {CourseBookingComponent} from './features/courses/components/course-booking/course-booking.component';
import {CourseConfirmComponent} from './features/courses/components/course-confirm/course-confirm.component';
import {CourseSuccessComponent} from './features/courses/components/course-success/course-success.component';
import {PatientComponent} from './features/patient-management/components/patient/patient.component';
import {AppointmentsComponent} from './features/patient-management/components/appointments/appointments.component';
import {AppointmentDetailsComponent} from './features/patient-management/components/appointment-details/appointment-details.component';
import {CoursesScheduleComponent} from './features/courses/components/course-schedule/course-schedule.component';
import {StartupComponent} from './features/startup/components/startup.component';
import {SetPasswordComponent} from './features/authentication/components/set-password/set-password.component';
import {VerifyEmailAddressComponent} from './features/authentication/components/verify-email-address/verify-email-address.component';
import {WaitlistComponent} from './features/waitlist/components/waitlist/waitlist.component';
import {GrantAccessComponent} from './features/authentication/components/grant-access/grant-access.component';
import {AppLayoutComponent} from './core/components/app-layout/app-layout.component';

export const routes: Routes = [
  // outside AppLayoutComponent and the StartupComponent shell on purpose: patients arrive straight
  // from a link in a mail or text, with no account and none of the customer/location context that
  // shell establishes. The page renders its own header, since the app bar's account button would
  // send a patient with no login into the profile area.
  {path: "waitlist/:reference", component: WaitlistComponent},
  {
    path: "", component: AppLayoutComponent, children: [
      {path: "set-password", component: SetPasswordComponent},
      {path: "verify-email-address", component: VerifyEmailAddressComponent},
      {path: "grant-access", component: GrantAccessComponent},
      {
        path: "", component: StartupComponent, children: [
          {path: "", redirectTo: "profile", pathMatch: "full"},
          {path: "login", component: LoginPageComponent},
          {
            path: "profile", component: ProfileComponent, children: [
              {path: "", component: PatientComponent},
              {path: "appointments", component: AppointmentsComponent},
              {path: "appointment-details", component: AppointmentDetailsComponent},
            ]
          },
          {path: "register", component: RegisterComponent},
          {
            path: "appointment-selection", component: AppointmentSelectionComponent, children: [
              {path: "", component: AppointmentFiltersComponent},
              {path: "date-selection", component: DateSelectionComponent},
              {path: "time-selection", component: TimeSelectionComponent},
            ],
          },
          {
            path: "booking", component: BookingComponent, children: [
              {path: "", component: SelectedAppointmentComponent},
              {path: "login", component: BookingLoginComponent},
              {path: "confirm", component: ConfirmComponent},
            ],
          },
          {path: "success", component: SuccessComponent},
          {
            path: "courses", component: CoursesComponent, children: [
              {path: "", component: CourseListComponent},
            ],
          },
          {path: "course-schedule", component: CoursesScheduleComponent},
          {path: "course-booking/:id", component: CourseBookingComponent},
          {path: "course-confirm", component: CourseConfirmComponent},
          {path: "course-success", component: CourseSuccessComponent},
          {path: "**", redirectTo: "profile"}
        ]
      },
    ]
  },
  {path: "**", redirectTo: ""}
];
